import { Col, Form, InputNumber, Row } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getSystemSettings } from 'src/apis/master_data/systemSetting.api';
import { SystemConfigERPKeyEn, SystemConfigGroupEn } from 'src/constants/systemConfig.enum';
import type { SystemSettingAdd } from 'src/types/master_data/systemSetting.type';

interface ErpConfigProps {
  systemConfigData: SystemSettingAdd[];
  setSystemConfigData: React.Dispatch<React.SetStateAction<SystemSettingAdd[]>>;
}

const ErpConfig = ({ systemConfigData, setSystemConfigData }: ErpConfigProps) => {
  const [form] = Form.useForm();
  const [, setInvoiceDayGap] = useState<number>(0);
  const { t } = useTranslation();

  // Fetch ERP system settings on mount
  useEffect(() => {
    getSystemSettings(SystemConfigGroupEn.ERP).then((response) => {
      const settings = response.data;
      const erpSetting = settings.find(
        (item: SystemSettingAdd) =>
          item.group === SystemConfigGroupEn.ERP && item.key === SystemConfigERPKeyEn.InvoiceGRPORDayGap
      );
      if (erpSetting) {
        const value = parseInt(erpSetting.value) || 0;
        setInvoiceDayGap(value);
        form.setFieldValue('invoiceDayGap', value);
        // Initialize systemConfigData with current ERP settings
        setSystemConfigData([erpSetting]);
      }
    });
  }, [form, setSystemConfigData]);

  const handleInvoiceDayGapChange = (value: number | null) => {
    const numValue = value || 0;
    setInvoiceDayGap(numValue);
    form.setFieldValue('invoiceDayGap', numValue);

    // Update systemConfigData with new value
    const updatedConfig = {
      group: SystemConfigGroupEn.ERP,
      key: SystemConfigERPKeyEn.InvoiceGRPORDayGap,
      value: numValue.toString()
    };

    setSystemConfigData([updatedConfig]);
  };

  return (
    <div className='setting-tab-content'>
      <Form form={form} layout='vertical'>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item label={t('setting.erp.invoice.day.gap') as string} name='invoiceDayGap'>
              <InputNumber onChange={handleInvoiceDayGapChange} size='large' min={0} style={{ width: '100%' }} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ErpConfig;
